/* eslint-disable no-useless-escape */
// eslint-disable-next-line no-undef
tinymce.addI18n("it_IT", {
  Redo: "Ripristina",
  Undo: "Annulla",
  Cut: "Taglia",
  Copy: "Copia",
  Paste: "Incolla",
  "Select all": "Seleziona tutto",
  "New document": "Nuovo documento",
  Ok: "OK",
  Cancel: "Annulla",
  "Visual aids": "Aiuti visivi",
  Bold: "Grassetto",
  Italic: "Corsivo",
  Underline: "Sottolineato",
  Strikethrough: "Barrato",
  Superscript: "Apice",
  Subscript: "Pedice",
  "Clear formatting": "Cancella la formattazione",
  "Align left": "Allinea a sinistra",
  "Align center": "Allinea al centro",
  "Align right": "Allinea a destra",
  Justify: "Giustifica",
  "Bullet list": "Elenco puntato",
  "Numbered list": "Elenco numerato",
  "Decrease indent": "Riduci rientro",
  "Increase indent": "Aumenta rientro",
  Close: "Chiudi",
  Formats: "Formati",
  "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.":
    "Il browser non supporta l'accesso diretto alla cartella degli appunti. Usare i tasti di scelta rapida Ctrl+X/C/V.",
  Headers: "Intestazioni",
  "Header 1": "Intestazione 1",
  "Header 2": "Intestazione 2",
  "Header 3": "Intestazione 3",
  "Header 4": "Intestazione 4",
  "Header 5": "Intestazione 5",
  "Header 6": "Intestazione 6",
  Headings: "Titoli",
  "Heading 1": "Titolo 1",
  "Heading 2": "Titolo 2",
  "Heading 3": "Titolo 3",
  "Heading 4": "Titolo 4",
  "Heading 5": "Titolo 5",
  "Heading 6": "Titolo 6",
  Preformatted: "Preformattato",
  Div: "Div",
  Pre: "Pre",
  Code: "Codice",
  Paragraph: "Paragrafo",
  Blockquote: "Blockquote",
  Inline: "In linea",
  Blocks: "Blocchi",
  "Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.":
    "Incolla \u00e8 in modalit\u00e0 testo normale. I contenuti saranno incollati come testo normale se non viene disattivata questa opzione.",
  Fonts: "Caratteri",
  "Font Sizes": "Dimensioni caratteri",
  Class: "Classe",
  "Browse for an image": "Cerca un'immagine",
  OR: "OPPURE",
  "Drop an image here": "Rilasciare un'immagine qui",
  Upload: "Carica",
  Block: "Blocco",
  Align: "Allinea",
  Default: "Predefinito",
  Circle: "Circolo",
  Disc: "Disco",
  Square: "Quadrato",
  "Lower Alpha": "Alfabetico minuscolo",
  "Lower Greek": "Greco minuscolo",
  "Lower Roman": "Romano minuscolo",
  "Upper Alpha": "Alfabetico maiuscolo",
  "Upper Roman": "Romano maiuscolo",
  "Anchor...": "Ancoraggio...",
  Name: "Nome",
  Id: "ID",
  "Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.":
    "L'ID dovrebbe cominciare con una lettera, seguita unicamente da lettere, numeri, linee, punti, due punti o caratteri di sottolineatura.",
  "You have unsaved changes are you sure you want to navigate away?":
    "Ci sono modifiche non salvate, si \u00e8 sicuro di volere uscire?",
  "Restore last draft": "Ripristina l'ultima bozza",
  "Special characters...": "Caratteri speciali...",
  "Source code": "Codice sorgente",
  "Insert/Edit code sample": "Inserisci/modifica esempio di codice",
  Language: "Lingua",
  "Code sample...": "Esempio di codice...",
  "Color Picker": "Selezione colori",
  R: "R",
  G: "G",
  B: "B",
  "Left to right": "Da sinistra a destra",
  "Right to left": "Da destra a sinistra",
  "Emoticons...": "Emoticon...",
  "Metadata and Document Properties": "Metadata e propriet\u00e0 del documento",
  Title: "Titolo",
  Keywords: "Parole chiave",
  Description: "Descrizione",
  Robots: "Robot",
  Author: "Autore",
  Encoding: "Codifica",
  Fullscreen: "A tutto schermo",
  Action: "Azione",
  Shortcut: "Collegamento",
  Help: "Guida",
  Address: "Indirizzo",
  "Focus to menubar": "Imposta stato attivo per la barra dei menu",
  "Focus to toolbar": "Imposta stato attivo per la barra degli strumenti",
  "Focus to element path": "Imposta stato attivo per il percorso dell'elemento",
  "Focus to contextual toolbar":
    "Imposta stato attivo per la barra degli strumenti contestuale",
  "Insert link (if link plugin activated)":
    "Inserisci un collegamento (se \u00e8 attivato l'apposito plugin)",
  "Save (if save plugin activated)":
    "Salva (se \u00e8 attivato l'apposito plugin)",
  "Find (if searchreplace plugin activated)":
    "Trova (se \u00e8 attivato l'apposito plugin)",
  "Plugins installed ({0}):": "Plugin installati ({0}):",
  "Premium plugins:": "Plugin Premium:",
  "Learn more...": "Maggiori informazioni...",
  "You are using {0}": "Si sta utilizzando {0}",
  Plugins: "Plugin",
  "Handy Shortcuts": "Scorciatoie utili",
  "Horizontal line": "Linea orizzontale",
  "Insert/edit image": "Inserisci/modifica immagine",
  "Image description": "Descrizione immagine",
  Source: "Fonte",
  Dimensions: "Dimensioni",
  "Constrain proportions": "Mantieni proporzioni",
  General: "Generali",
  Advanced: "Avanzate",
  Style: "Stile",
  "Vertical space": "Spazio verticale",
  "Horizontal space": "Spazio orizzontale",
  Border: "Bordo",
  "Insert image": "Inserisci immagine",
  "Image...": "Immagine...",
  "Image list": "Elenco immagini",
  "Rotate counterclockwise": "Ruota in senso antiorario",
  "Rotate clockwise": "Ruota in senso orario",
  "Flip vertically": "Rifletti verticalmente",
  "Flip horizontally": "Rifletti orizzontalmente",
  "Edit image": "Modifica immagine",
  "Image options": "Opzioni immagine",
  "Zoom in": "Ingrandisci",
  "Zoom out": "Zoom indietro",
  Crop: "Ritaglia",
  Resize: "Ridimensiona",
  Orientation: "Orientamento",
  Brightness: "Luminosit\u00e0",
  Sharpen: "Nitidezza",
  Contrast: "Contrasto",
  "Color levels": "Livelli di colore",
  Gamma: "Gamma",
  Invert: "Inverti",
  Apply: "Applica",
  Back: "Indietro",
  "Insert date/time": "Inserisci data/ora",
  "Date/time": "Data/ora",
  "Insert/Edit Link": "Inserisci/modifica collegamento",
  "Insert/edit link": "Inserisci/modifica collegamento",
  "Text to display": "Testo da visualizzare",
  Url: "URL",
  "Open link in...": "Apri collegamento in...",
  "Current window": "Finestra corrente",
  None: "Nessuno",
  "New window": "Nuova finestra",
  "Remove link": "Rimuovi collegamento",
  Anchors: "Ancoraggi",
  "Link...": "Collegamento...",
  "Paste or type a link": "Incolla o digita un collegamento",
  "The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?":
    "L'URL inserito sembra essere un indirizzo email. Si vuole aggiungere il necessario prefisso mailto:?",
  "The URL you entered seems to be an external link. Do you want to add the required http:// prefix?":
    "L'URL inserito sembra essere un collegamento esterno. Si vuole aggiungere il necessario prefisso http://?",
  "Link list": "Elenco collegamenti",
  "Insert video": "Inserisci video",
  "Insert/edit video": "Inserisci/modifica video",
  "Insert/edit media": "Inserisci/modifica oggetti multimediali",
  "Alternative source": "Sorgente alternativa",
  "Alternative source URL": "URL sorgente alternativa",
  "Media poster (Image URL)":
    "Poster dell'oggetto multimediale (URL dell'immagine)",
  "Paste your embed code below:":
    "Incolla il codice d'incorporamento di seguito:",
  Embed: "Incorpora",
  "Media...": "Oggetto multimediale...",
  "Nonbreaking space": "Spazio indivisibile",
  "Page break": "Interruzione di pagina",
  "Paste as text": "Incolla senza formattazioni",
  Preview: "Anteprima",
  "Print...": "Stampa...",
  Save: "Salva",
  Find: "Trova",
  "Replace with": "Sostituisci con",
  Replace: "Sostituisci",
  "Replace all": "Sostituisci tutto",
  Previous: "Indietro",
  Next: "Avanti",
  "Find and replace...": "Trova e sostituisci...",
  "Could not find the specified string.":
    "Impossibile trovare la stringa specificata.",
  "Match case": "Maiuscole/minuscole",
  "Find whole words only": "Trova solo parole intere",
  "Spell check": "Controllo ortografia",
  Ignore: "Ignora",
  "Ignore all": "Ignora tutto",
  Finish: "Fine",
  "Add to Dictionary": "Aggiungi al dizionario",
  "Insert table": "Inserisci tabella",
  "Table properties": "Propriet\u00e0 della tabella",
  "Delete table": "Elimina tabella",
  Cell: "Cella",
  Row: "Riga",
  Column: "Colonna",
  "Cell properties": "Propriet\u00e0 cella",
  "Merge cells": "Unisci le celle",
  "Split cell": "Dividi la cella",
  "Insert row before": "Inserisci riga prima",
  "Insert row after": "Inserisci riga dopo",
  "Delete row": "Elimina riga",
  "Row properties": "Propriet\u00e0 della riga",
  "Cut row": "Taglia riga",
  "Copy row": "Copia riga",
  "Paste row before": "Incolla riga prima",
  "Paste row after": "Incolla riga dopo",
  "Insert column before": "Inserisci colonna prima",
  "Insert column after": "Inserisci colonna dopo",
  "Delete column": "Elimina colonna",
  Cols: "Colonne",
  Rows: "Righe",
  Width: "Larghezza",
  Height: "Altezza",
  "Cell spacing": "Spaziatura tra celle",
  "Cell padding": "Spaziatura interna celle",
  "Show caption": "Mostra didascalia",
  Left: "Sinistra",
  Center: "Centro",
  Right: "Destra",
  "Cell type": "Tipo di cella",
  Scope: "Ambito",
  Alignment: "Allineamento",
  "H Align": "Allineamento H",
  "V Align": "Allineamento V",
  Top: "In alto",
  Middle: "Centrato",
  Bottom: "In basso",
  "Header cell": "Cella d'intestazione",
  "Row group": "Gruppo di righe",
  "Column group": "Gruppo di colonne",
  "Row type": "Tipo di riga",
  Header: "Intestazione",
  Body: "Corpo",
  Footer: "Pi\u00e8 di pagina",
  "Border color": "Colore del bordo",
  "Insert template...": "Inserisci modello...",
  Templates: "Modelli",
  Template: "Modello",
  "Text color": "Colore testo",
  "Background color": "Colore dello sfondo",
  "Custom...": "Personalizzato...",
  "Custom color": "Colore personalizzato",
  "No color": "Nessun colore",
  "Remove color": "Rimuovi colore",
  "Table of Contents": "Sommario",
  "Show blocks": "Mostra blocchi",
  "Show invisible characters": "Mostra caratteri invisibili",
  "Word count": "Conteggio parole",
  "Words: {0}": "Parole: {0}",
  "{0} words": "{0} parole",
  File: "File",
  Edit: "Modifica",
  Insert: "Inserisci",
  View: "Visualizza",
  Format: "Formato",
  Table: "Tabella",
  Tools: "Strumenti",
  "Powered by {0}": "Con tecnologia {0}",
  "Rich Text Area. Press ALT-F9 for menu. Press ALT-F10 for toolbar. Press ALT-0 for help":
    "Area di testo RTF. Premere ALT-F9 per il menu. Premere ALT-F10 per la barra degli strumenti. Premere ALT-0 per la guida.",
  "Image title": "Titolo immagine",
  "Border width": "Larghezza del bordo",
  "Border style": "Stile del bordo",
  Error: "Errore",
  Warn: "Avviso",
  Valid: "Valido",
  "To open the popup, press Shift+Enter":
    "Per aprire il popup, premere Shift+Invio",
  "Rich Text Area. Press ALT-0 for help.":
    "Area di testo RTF. Premere ALT-0 per la guida.",
  "System Font": "Carattere di sistema",
  "Failed to upload image: {0}": "Caricamento immagine fallito: {0}",
  "Failed to load plugin: {0} from url {1}":
    "Caricamento plugin fallito: {0} dall'URL {1}",
  "Failed to load plugin url: {0}": "Caricamento URL plugin fallito: {0}",
  "Failed to initialize plugin: {0}": "Inizializzazione plugin fallita: {0}",
  example: "esempio",
  Search: "Cerca",
  All: "Tutto",
  Currency: "Valuta",
  Text: "Testo",
  Quotations: "Citazioni",
  Mathematical: "Caratteri matematici",
  "Extended Latin": "Latino esteso",
  Symbols: "Simboli",
  Arrows: "Frecce",
  "User Defined": "Definito dall'utente",
  "dollar sign": "simbolo del dollaro",
  "currency sign": "simbolo di valuta",
  "euro-currency sign": "simbolo dell'euro",
  "colon sign": "simbolo del col\u00f3n",
  "cruzeiro sign": "simbolo del cruzeiro",
  "french franc sign": "simbolo del franco francese",
  "lira sign": "simbolo della lira",
  "mill sign": "simbolo del mill",
  "naira sign": "simbolo della naira",
  "peseta sign": "simbolo della peseta",
  "rupee sign": "simbolo della rup\u00eca",
  "won sign": "simbolo del won",
  "new sheqel sign": "simbolo del nuovo shekel",
  "dong sign": "simbolo del dong",
  "kip sign": "simbolo del kip",
  "tugrik sign": "simbolo del tugrik",
  "drachma sign": "simbolo della dracma",
  "german penny symbol": "simbolo del pfennig tedesco",
  "peso sign": "simbolo del peso",
  "guarani sign": "simbolo del guaran\u00ec",
  "austral sign": "simbolo dell'austral",
  "hryvnia sign": "simbolo della hryvnia",
  "cedi sign": "simbolo del cedi",
  "livre tournois sign": "simbolo della lira di Tours",
  "spesmilo sign": "simbolo dello spesmilo",
  "tenge sign": "simbolo del tenge",
  "indian rupee sign": "simbolo della rup\u00eca indiana",
  "turkish lira sign": "simbolo della lira turca",
  "nordic mark sign": "simbolo del marco nordico",
  "manat sign": "simbolo del manat",
  "ruble sign": "simbolo del rublo",
  "yen character": "simbolo dello yen",
  "yuan character": "simbolo dello yuan",
  "yuan character, in hong kong and taiwan":
    "simbolo dello yuan, Hong Kong e Taiwan",
  "yen/yuan character variant one": "simbolo yen/yuan variante uno",
  "Loading emoticons...": "Caricamento emoticon in corso",
  "Could not load emoticons": "Impossibile caricare emoticon",
  People: "Persone",
  "Animals and Nature": "Animali e natura",
  "Food and Drink": "Cibi e bevande",
  Activity: "Attivit\u00e0",
  "Travel and Places": "Viaggi e luoghi",
  Objects: "Oggetti",
  Flags: "Bandiere",
  Characters: "Caratteri",
  "Characters (no spaces)": "Caratteri (senza spazi)",
  "Error: Form submit field collision.":
    "Errore: Conflitto di campi nel modulo inviato.",
  "Error: No form element found.": "Errore: Nessun elemento di modulo trovato.",
  Update: "Aggiorna",
  "Color swatch": "Campione di colore",
  Turquoise: "Turchese",
  Green: "Verde",
  Blue: "Blu",
  Purple: "Viola",
  "Navy Blue": "Blu scuro",
  "Dark Turquoise": "Turchese scuro",
  "Dark Green": "Verde scuro",
  "Medium Blue": "Blu medio",
  "Medium Purple": "Viola medio",
  "Midnight Blue": "Blu notte",
  Yellow: "Giallo",
  Orange: "Arancio",
  Red: "Rosso",
  "Light Gray": "Grigio chiaro",
  Gray: "Grigio",
  "Dark Yellow": "Giallo scuro",
  "Dark Orange": "Arancio scuro",
  "Dark Red": "Rosso scuro",
  "Medium Gray": "Grigio medio",
  "Dark Gray": "Grigio scuro",
  Black: "Nero",
  White: "Bianco",
  "Switch to or from fullscreen mode":
    "Attiva/disattiva la modalit\u00e0 schermo intero",
  "Open help dialog": "Apri la finestra di aiuto",
  history: "cronologia",
  styles: "stili",
  formatting: "formattazione",
  alignment: "allineamento",
  indentation: "indentazione",
  "permanent pen": "penna indelebile",
  comments: "commenti",
});
